<template>
  <div class="pb-48">
    <template v-for="(item, idx) in getGroups()">
      <T1OffersCategoryGroupRowSection
        :key="idx"
        :color="options.colors[idx]"
        :groupName="item.nazwa"
        :groupUrl="item.params"
        :optionsUrl="options.url"
        :pricesUrl="options.pricesUrl"
        :type="options.groups[idx].rodzaj"
        :nntab="options.groups[idx].nazwa"
      />
    </template>
  </div>
</template>

<script>
import T1OffersCategoryGroupRowSection from "./T1OffersCategoryGroupRowSection";

export default {
  name: "offers-category-group-rows",
  props: {
    options: [Array, Object],
  },
  methods: {
    getGroups() {
      return this.options.groups;
    },
  },
  components: {
    T1OffersCategoryGroupRowSection,
  },
};
</script>
